<template v-if="globaljs.acc_type !== 'hospital'">
	<include-header />

	<section id="lab_order">
		<div class="content">
			<div class="contIn">
				<div class="sub_cont">
					<div class="boardTit">입출고 현황</div>
					<div class="sub_contBox">
						<AiorderStatus />
					</div>
				</div>
			</div>
		</div>
	</section>

	<include-footer />
</template>

<script>
import header from '../components/layout/header.vue'
import footer from '../components/layout/footer.vue'

export default {
	name: 'App',
	components: {
		'include-header': header,
		'include-footer': footer
	}
}
</script>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';
import AiorderStatus from '@/components/layout/aiorder_status'

const route = useRoute();
const router = useRouter();

if(globaljs.acc_type === 'hospital') { commonjs.authSwal(); }
</script>